export function LeavingClues() {
  return (
    <section
      data-testid="believing-happy-clues-section"
      className="relative bg-[#FAFAF8]"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-10 pt-[53px] md:pt-[70px] pb-24 md:pb-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-x-10 gap-y-8">

          {/* Headline — anchored left, narrower column */}
          <div className="lg:col-span-5 lg:col-start-1 reveal">
            <h2
              data-testid="believing-happy-clues-headline"
              className="font-display text-[32px] sm:text-[42px] lg:text-[46px] leading-[1.16] tracking-tight text-[#1C1917] max-w-md"
            >
              Your life has probably been leaving clues everywhere.
            </h2>
          </div>

          {/* Body — offset right, the list + transition + closing */}
          <div className="lg:col-span-6 lg:col-start-7 reveal">
            <div className="space-y-1.5 text-lg md:text-xl leading-relaxed text-[#57534E] max-w-xl">
              <p>In the screenshots you keep saving.</p>
              <p>The place you always say you want to visit.</p>
              <p>
                The class you&rsquo;ve looked up three times but
                haven&rsquo;t taken.
              </p>
              <p>
                The person whose life makes you think, I want some version
                of that.
              </p>
              <p>The thing you loved when you were twelve.</p>
              <p>The idea that keeps resurfacing at inconvenient times.</p>
              <p>The conversation you can&rsquo;t stop thinking about.</p>
              <p>
                The ridiculous thing that makes you laugh every single time.
              </p>
            </div>

            <div className="mt-6 space-y-1 text-lg md:text-xl leading-relaxed text-[#1C1917] max-w-xl">
              <p>Not every clue needs to become a goal.</p>
              <p>Some are simply invitations to look closer.</p>
            </div>

            <div className="mt-8 max-w-xl">
              <p className="text-lg md:text-xl leading-relaxed text-[#57534E]">
                Curiosity doesn&rsquo;t always know where it&rsquo;s going.
              </p>
              <p
                data-testid="believing-happy-clues-closing-line"
                className="mt-2 font-display italic text-2xl md:text-3xl leading-snug text-[#159E9A]"
              >
                That&rsquo;s part of what makes it useful.
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
